<template lang="pug">
  #app
    component(:is="template")
      slot
</template>

<script>

import { mapGetters } from "vuex";
import axios from "axios";
import FauxContainer from "@/templates/faux_marriott_gpns/Container";
import InnfluxContainer from "@/templates/innflux_final/Container";

export default {
  name: "App",
  components: {
    FauxContainer,
    InnfluxContainer
  },
  computed: {
    ...mapGetters(["template"])
  },
  mounted() {
    // Update page title.
    this.$store.watch((state) => {
      return state.common.title
    }, (title) => {
      document.title = title
      console.log('title updated')
    }, {
      deep: true
    })
    console.log('template is..');
    console.log(this.template);
  }
}
</script>

<style scoped>

</style>